import { httpRequest } from "../../../../utils/HttpRequest";
import { IPage, ISearchPage } from "@/types/ScmTypes";
import { ISaleSoList, ISaleSoFields, ISaleSoDetail, ISaleSoSearch, Detailed } from "./saleOrderTypes"
class SaleOrderService {
    async page(searchVo: ISaleSoSearch) {
        const apiUrl = "/vrm-sa/sale/order/findPage";
        return await httpRequest.post<ISaleSoList>(apiUrl, searchVo);
    }
    async one(saleOrderCode: string) {
        const apiUrl = `/vrm-sa/sale/order/findById/${saleOrderCode}`;
        return await httpRequest.get<ISaleSoDetail>(apiUrl);
    }

    async insert(insertVo: ISaleSoFields) {
        const apiUrl = "/vrm-sa/sale/order/insert";
        return await httpRequest.post<ISaleSoDetail>(apiUrl, insertVo);
    }
    async update(updateVo: ISaleSoFields) {
        const apiUrl = "/vrm-sa/sale/order/update";
        return await httpRequest.post<boolean>(apiUrl, updateVo);
    }
    //明细删除
    async materialDelete(params: Detailed) {
        const apiUrl = "/vrm-sa/sale/order/materialDelete";
        return await httpRequest.post<boolean>(apiUrl, params);
    }
    //导出
    async export(params: ISaleSoFields) {
        const apiUrl = "/vrm-sa/sale/order/export";
        return await httpRequest.postFile(apiUrl, params, { timeout: 300000 });
    }
    //转销售单
    async transfer(saleOrderCode: string) {
        const apiUrl = `/vrm-sa/sale/order/transfer/${saleOrderCode}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
    // //详情导入
    // async invalidate(){
    //     const apiUrl = "/vrm2-sa/sale/order/detail/downloadTpl";
    //     return await httpRequest.getFile<boolean>(apiUrl);
    // }
    //下载模板
    async downloadTpl() {
        const apiUrl = "/vrm-sa/sale/detail/downloadTpl";
        return await httpRequest.getFile<boolean>(apiUrl);
    }
    //作废
    async invalidate(params: object) {
        const apiUrl = "/vrm-sa/sale/order/invalidate";
        return await httpRequest.post<boolean>(apiUrl, params,{ timeout: 600000 });
    }
    //详情导出
    async detailsExport(params: object) {
        const apiUrl = "/vrm-sa/sale/order/detailsExport";
        return await httpRequest.postFile(apiUrl, params, { timeout: 600000 });
    }
    //打印次数
    async printNum(params: object) {
        const apiUrl = '/vrm-sa/sale/order/printing';
        return await httpRequest.post(apiUrl, params);
    }
}

export const saleOrderService = new SaleOrderService();